import Hero from "../../components/Hero";
import MortgagesImage from "../../../assets/images/Mortgages1.jpg";
import Accordion from "../../components/Accordion";
import SecondaryButton from "../../components/buttons/SecondaryButton";

const Mortgages = () => {
  return (
    <div>
      <Hero
        backgroundImage={MortgagesImage}
        title="Mortgages"
        subtitle="OUR SERVICES"
      />
      <div className="landing-page">
        <div className="column align-center">
          <div className="title-semibold primary">Types of Mortgages:</div>
          <Accordion title="Standard Variable Rate (SVR)">
            In a Standard Variable Rate (SVR) mortgage, the borrower’s monthly
            repayments are based on the prevailing rates of interest their
            lender charges and not the Bank of England (BoE) base rate. In other
            words, it is entirely the lender’s decision on the rate of interest
            they charge the borrower.
            <br />
            <div style={{ height: "10px" }} />
            Although the rate of interest charged in an SVR mortgage can be
            heavily influenced by changes in the Bank of England base rate.
            Whenever the bank raises or lowers the base rate, the lender can do
            the same or ignore the change altogether. On occasions, the lender
            may increase or decrease their rates of interest even if the BoE has
            not changed theirs. The rate of interest charged on SVR mortgages
            can often range from 2% - 5% above the base rate - or more.
          </Accordion>
          <Accordion title="Fixed Rate">
            The least risky of investment options are those offered by National
            Savings, which raises money on behalf of the UK Government. While
            investment returns are not exceptional and some involve tying your
            money up for long periods, they are nevertheless stable and in some
            cases can be paid tax free.
          </Accordion>
          <Accordion
            title="Second Charge
"
          >
            The least risky of investment options are those offered by National
            Savings, which raises money on behalf of the UK Government. While
            investment returns are not exceptional and some involve tying your
            money up for long periods, they are nevertheless stable and in some
            cases can be paid tax free.
          </Accordion>
          <Accordion
            title="Tracker Mortgages
"
          >
            The least risky of investment options are those offered by National
            Savings, which raises money on behalf of the UK Government. While
            investment returns are not exceptional and some involve tying your
            money up for long periods, they are nevertheless stable and in some
            cases can be paid tax free.
          </Accordion>
          <Accordion
            title="Offset Mortgages

"
          >
            The least risky of investment options are those offered by National
            Savings, which raises money on behalf of the UK Government. While
            investment returns are not exceptional and some involve tying your
            money up for long periods, they are nevertheless stable and in some
            cases can be paid tax free.
          </Accordion>
          <Accordion
            title="Buy-to-Let / Holiday Lets

"
          >
            The least risky of investment options are those offered by National
            Savings, which raises money on behalf of the UK Government. While
            investment returns are not exceptional and some involve tying your
            money up for long periods, they are nevertheless stable and in some
            cases can be paid tax free.
          </Accordion>
          {/* <Accordion
            title="Does the type of property affect my mortgage?

"
          >
            <div>
              Yes, some properties may be less acceptable to lenders. For
              example:
              <ul className="military-insurance-list">
                <li>Flats above commercial premises</li>
                <li>Studio flats</li>
                <li>Ex-local authority properties</li>
              </ul>
              These may limit your mortgage options. <br />
              Listed buildings or properties in protected areas may also have
              restrictions on alterations and maintenance
            </div>
          </Accordion>
          <Accordion title="How long can a mortgage last?">
            Mortgage providers set a maximum term (number of years) over which
            the loan must be repaid. The full balance must be cleared by the end
            of this period.
          </Accordion>
          <Accordion
            title="What else should I keep in mind when applying for a mortgage?
"
          >
            It’s important to understand the risks involved, including changes
            in interest rates or income. Speaking to a mortgage adviser can help
            you understand affordability and make informed decisions.
          </Accordion> */}
        </div>
        {/* <div className="light-row reverse">
          <div className="content-semibold primary">
            This content is for general guidance only and does not constitute
            financial advice.
          </div>
        </div> */}
      </div>
      <div className="primary-container">
        <div className="column align-left">
          <div className="content-semibold">
            What is the difference in repayment types?
          </div>
          <div className="content">
            Once your mortgage application has been accepted in principal, you
            may have the option of deciding how you repay the loan: on a
            ‘repayment’ basis, or on an ‘interest only’ basis.
          </div>
          <div className="content-semibold">Repayment Mortgage</div>
          <div className="content">
            With a repayment mortgage, your monthly repayments cover both
            capital and interest on the loan. As the term continues, the amount
            outstanding on the loan reduces so the full amount of the loan will
            have been repaid at the end of the term as long as you have made all
            your payments on time. No other repayment vehicle is needed and it
            avoids the risk of investing (e.g. in the stock market). If you
            remortgage, you may be tempted to extend the end repayment date in
            order to lower your monthly payments. However, this means that the
            amount you repay overall increases over time.
          </div>
          <div className="content-semibold">Interest Only Mortgage</div>
          <div className="content">
            With an interest-only mortgage, your payments to the lender cover
            only the interest on the loan (i.e. they do not repay any of the
            capital). The total amount of your debt does not reduce over time
            and the full amount of the loan still has to be repaid to the lender
            at the end of the term, so you will need to ensure you have that
            money ready.
          </div>
        </div>
      </div>
      <div className="footer-legal">
        <div className="footer-legal-text">
          <div className="column align-center">
            <div className=" content-semibold primary">
              There are a range of different mortgage products with specific
              eligibility/terms/rates – to talk through what could be best for
              your circumstances and your financial future, book in a call with
              us today!
            </div>
            <SecondaryButton
              text="Book a Call"
              onClick={() => {
                window.location.href = "/contact";
              }}
            />
          </div>
        </div>
      </div>
      <div
        className="content-semibold primary"
        style={{ marginTop: "30px", textAlign: "center", marginBottom: "30px" }}
      >
        YOUR HOME MAY BE REPOSSESSED IF YOU DO NOT KEEP UP REPAYMENTS ON YOUR
        MORTGAGE.
      </div>
    </div>
  );
};

export default Mortgages;
